<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播结算</h1>
    <el-row class="search">
      <el-date-picker
        v-model="search.datetime"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="retainedOptions"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-input
        style="width: 160px"
        v-model="search.rid"
        placeholder="请输入主播id"
      ></el-input>
      <el-select style="width: 160px" v-model="search.country" placeholder>
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      <el-input
        style="width: 160px"
        v-model="search.agentName"
        placeholder="请输入代理名"
      ></el-input>
      <el-button type="warning" @click="query" :loading="login1">
        查询
      </el-button>
      <el-button type="success" @click="downloadTable" :loading="login2">
        下载
      </el-button>
    </el-row>
    <el-row>
      <el-table
        :data="datalist"
        style="width: 100%"
        v-loading="login1"
        height="60vh"
        stripe
        border
      >
        <el-table-column prop="date" label="数据日期"></el-table-column>
        <el-table-column prop="rid" label="主播ID"></el-table-column>
        <el-table-column prop="name" label="昵称"></el-table-column>
        <el-table-column prop="country" label="主播国家"></el-table-column>
        <el-table-column prop="language" label="语言"></el-table-column>
        <el-table-column prop="agentName" label="代理名"></el-table-column>
        <el-table-column prop="agentCreator" label="代理创建人"></el-table-column>
        <el-table-column prop="registerDate" label="注册日期"></el-table-column>
        <el-table-column
          prop="examineScore"
          label="二筛转正等级"
        ></el-table-column>
        <el-table-column prop="platform" label="平台">
          <template slot-scope="scope">
            {{ scope.row.platform == 1 ? 'Android' : 'IOS' }}
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="安装渠道"></el-table-column>
        <el-table-column
          prop="onlineTime"
          label="当期在线时长-min"
        ></el-table-column>
        <el-table-column
          prop="liveTime"
          label="当期Live时长-min"
        ></el-table-column>
        <el-table-column prop="callIncome" label="通话收入"></el-table-column>
        <el-table-column prop="giftIncome" label="礼物收入"></el-table-column>
        <el-table-column prop="taskIncome" label="任务收入"></el-table-column>
        <el-table-column prop="otherIncome" label="其他收入"></el-table-column>
        <el-table-column
          prop="totalIncome"
          label="当期总收入"
        ></el-table-column>
        <el-table-column prop="gold" label="账户余额"></el-table-column>
      </el-table>
    </el-row>
  </el-card>
</template>
<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry } from '@/utils/normalApi.js'
export default {
  data () {
    return {
      login1: false,
      login2: false,
      search: {
        datetime: [datainfor(2), datainfor(1)],
        rid: '',
        country: 'all',
        agentName: ''
      },
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      countryList: [],
      datalist: []
    }
  },
  created () {
    this.getCountry_()
  },
  methods: {
    async query () {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.settlement_detail,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          startDate: this.search.datetime[0],
          endDate: this.search.datetime[1],
          agentName: this.search.agentName,
          rid: this.search.rid,
          country:
            this.search.country == 'all' || this.search.country == 'total'
              ? null
              : this.search.country
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.datalist = res.data.data
    },
    async downloadTable () {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.settlement_detail_dwn,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          startDate: this.search.datetime[0],
          endDate: this.search.datetime[1],
          agentName: this.search.agentName,
          rid: this.search.rid,
          country:
            this.search.country == 'all' || this.search.country == 'total'
              ? null
              : this.search.country
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '主播结算报表' + '')
    },
    async getCountry_ () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  > * {
    margin: 0 3px;
  }
}
</style>
